module.exports = __webpack_public_path__ + "img/DE06630.fa9725eb.png";